import React from 'react';
import styled from '@emotion/styled';
import { Config } from '@vm/omega-shared-component-webapp';

const ImageContent = styled.img({
  width: '100%',
});

type Props = {
  logo: string;
};

export const BenefitsTpLogo: React.FC<Props> = ({ logo }) => {
  return <ImageContent src={`${Config.get('image_cdn_base_url')}/${logo}`} alt='Product screenshot' data-testid='mp-product-benefits-logo' />;
};
